let GeocoderInstance = null;

/**
 * Creates and returns a singleton instance of Google Maps Geocoder service.
 *
 * @returns google.maps.Geocoder instance or null
 */
export const getGeocoderInstance = () => {
  if (!window.google) return GeocoderInstance;

  try {
    if (!GeocoderInstance) GeocoderInstance = new window.google.maps.Geocoder();
    return GeocoderInstance;
  } catch (err) {
    console.warn(err);
    return GeocoderInstance;
  }
};
